import React from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Box,
  Flex,
  ModalFooter,
  Divider,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useToast } from 'components/hooks/useToast';
import useOneOnOnePageParams from 'screens/oneOnOneRabbit/hooks/useOneOnOnePageParams';

import { Archive, Cross } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextHeader3 } from 'uiToolkitV1/Typography';

import { archiveOneOnOneMeeting } from '../../services';

export const StyleCloseButton = styled(Button)`
  position: absolute;
  left: -14px;
  top: -14px;
  padding: 2px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #f5f7f9;
  &:hover {
    background-color: #125aa9;
  }
`;

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  onSave?: () => void;
  isCentered?: boolean;
  employeeName?: string;
  masterIdFromProp?: number;
}

const ArchiveMeetingModal = ({ isOpen, onClose, onSave, employeeName, isCentered, masterIdFromProp }: Props) => {
  // const { startTimeTs } = useOneOnOneInstanceDetails({
  //   masterId: 1,
  //   instanceId: 1
  // });
  const toast = useToast();

  const { masterId } = useOneOnOnePageParams();

  const masterIdToUse = masterIdFromProp ?? masterId;

  const onMeetingArchive = async () => {
    onClose();
    try {
      await archiveOneOnOneMeeting({
        masterId: Number(masterIdToUse),
        isArchive: true,
      });
      onSave && onSave();
    } catch (error) {
      toast({
        title: error?.message || 'Error while archiving 1:1',
        status: 'error',
      });
      console.error('Error archiving meeting : ', error);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered}>
      <ModalOverlay />
      <ModalContent position="relative" maxH="204px" maxW={isMobileView() ? '300px' : '578px'}>
        <ModalHeader position="relative">
          <Flex>
            <Archive boxSize="24px" color="#666666" />
            <TextHeader3 ml="11px" bold>
              Archive Recurring Event
            </TextHeader3>
          </Flex>

          <StyleCloseButton
            variant="filled"
            color="black"
            // eslint-disable-next-line react/no-unstable-nested-components
            StartIcon={(props) => <Cross {...props} boxSize="20px" />}
            onClick={onClose}
          />
        </ModalHeader>
        <Divider opacity={1} color="#EBEFF3" />

        <ModalBody p="26px 30px">
          <Box display="flex">
            {employeeName ? (
              <TextBodyMedium>
                {`If you archive this 1:1, no future 1:1 meetings with ${employeeName} will be setup. Do you want to archive this 1:1?`}
              </TextBodyMedium>
            ) : (
              <TextBodyMedium>
                If you archive this 1:1, no future 1:1 meetings will be setup. Do you want to archive this 1:1?
              </TextBodyMedium>
            )}
          </Box>
        </ModalBody>
        <ModalFooter
          sx={{
            background: '#F5F7F9',
            borderTop: '1px solid #CED7DF',
            borderRadius: '0px 0px 8px 8px',
          }}
        >
          <Button
            sx={{
              '&>p': {
                marginLeft: 0,
              },
            }}
            mr="auto"
            variant="tertiary"
            onClick={onClose}
          >
            No
          </Button>
          <Button onClick={onMeetingArchive}>Yes</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export { ArchiveMeetingModal };
